import { QuoteReadOnlyState } from 'Types/QuoteReadOnly/App';
import { parseHistoryChat, parseReadOnlyDetails } from 'Parsers/readOnlyParser';
import { getCrossQuotationById, getChathistory, getCompanyChatInfo } from 'Api/quotationApi';

const state: QuoteReadOnlyState = {
  requesting: {
    details: false,
    history: false,
    companyinfo: false
  },

  readonlyDetails: null,
  chatHistory: [],
  selectedCompanyId: null,
  companyInfo: null,

  mobileDetailsView: {
    chat: false,
    requestInfo: true,
  }

}

const mutations = {
  request_start(state, type) {
    state.requesting[type] = true
  },

  request_success(state, type) {
    state.requesting[type] = false
  },

  request_failure(state, type) {
    state.requesting[type] = false
  },

  set_readonly_details(state, readOnlyDetails) {
    state.readonlyDetails = readOnlyDetails
  },

  set_chat_history(state, chatHistory) {
    state.chatHistory = chatHistory
  },

  set_selected_company_id(state, companyId){
    state.selectedCompanyId = companyId

  },

  set_company_info(state, info){
    state.companyInfo = info

  },
  set_mobile_view_chat(state) {
    state.mobileDetailsView.chat = true
    state.mobileDetailsView.requestInfo = false
  },

  set_mobile_view_request_info(state) {
    state.mobileDetailsView.requestInfo = true
    state.mobileDetailsView.chat = false
  },
}

const actions = {
  openRequestInfoMobile({ commit }) {
    commit('set_mobile_view_request_info')
  },

  openChatHistoryMobile({ commit }) {
    commit('set_mobile_view_chat')
  },

 async getInfo({ commit }, id) {
  commit('request_start', 'details')

    try {
      const  { data }  = await getCrossQuotationById(id)
      const parsedDate = parseReadOnlyDetails(data)

      commit('set_readonly_details', parsedDate)

      commit('request_success', 'details')

      return data
    } catch (err) {
      commit('request_failure', 'details')


      throw err
    }

  },

  async getChatHistory({ commit }, idList) {
    commit('request_start', 'history')

    try {
      commit('request_success', 'history')

      const { data } = await getChathistory(idList.guid, idList.companyId)
      const parsedHistory = data.map(parseHistoryChat)
      commit('set_chat_history', parsedHistory)

      commit('set_selected_company_id', idList.companyId)

      return data
    } catch (error) {
      commit('request_failure', 'history')

      throw error
    }
  },

  async getCompanyInfo({ commit }, idList) {
    commit('request_start', 'companyInfo')

    try {
      commit('request_success', 'companyInfo')

      const { data } = await getCompanyChatInfo(idList.guid, idList.companyId)

      commit('set_company_info', data)

      return data
    } catch (error) {
      commit('request_failure', 'companyInfo')

      throw error
    }
  },

  removeSelectedId({commit}){
    commit("set_selected_company_id", null)
  }

}

export default {
  namespaced: true,

  state,
  mutations,
  actions,
}